import { useQuery } from '@tanstack/react-query';
import getLastIaRun from '../services/IaResultsService';
export default function useGetLastIaRun() {
    return useQuery({
        queryKey: ['ia-last-run'],
        queryFn: () => getLastIaRun(),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        retry: 3
    });
}
